<template lang="pug">
div 
	div.tw-mb-4.tw-uppercase(class="tw-text-[#636a77] tw-font-bold tw-mt-2" v-if="!isMobile" ) {{$t('sale.train_solution_price_grid.select', 'Seleziona servizio e offerta')}}
	div(v-if='travelSolution' v-for="(singleTrain, tk) in travelSolution.trains" :key="singleTrain.id")
		train-price-grid(:train='singleTrain' :travel-solution="travelSolution" :is-single="travelSolution.trains.length == 1")
		v-divider.tw-mt-2.tw-mb-6(v-if="tk < (travelSolution.trains.length - 1)")
</template>

<script setup>
import { inject } from 'vue';
import trainPriceGrid from './train-price-grid.vue';
import CustomizeOffer from '@/sale/components/tab2_travel_solutions/customize-offer/customize-solution.vue';
import {useI18n} from "vue-i18n";
import { useDisplay } from 'vuetify'

const travelSolution = inject('solution');
const i18n = useI18n();
const isMobile = inject('isMobile');
const emit = defineEmits(['expand', 'unexpand', 'addToCart', 'showMovementDetails', 'update:travel-solution']);
</script>